import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
var _excluded = ["authStrategy"];

var _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
// pkg/dist-src/index.js
import { getUserAgent } from "universal-user-agent";
import { Collection } from "before-after-hook";
import { request } from "@octokit/request";
import { graphql, withCustomRequest } from "@octokit/graphql";
import { createTokenAuth } from "@octokit/auth-token"; // pkg/dist-src/version.js

var VERSION = "5.0.2"; // pkg/dist-src/index.js

var noop = function noop() {};

var consoleWarn = console.warn.bind(console);
var consoleError = console.error.bind(console);
var userAgentTrail = "octokit-core.js/".concat(VERSION, " ").concat(getUserAgent());
var Octokit = (_class = /*#__PURE__*/function () {
  function Octokit() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Octokit);

    var hook = new Collection();
    var requestDefaults = {
      baseUrl: request.endpoint.DEFAULTS.baseUrl,
      headers: {},
      request: Object.assign({}, options.request, {
        // @ts-ignore internal usage only, no need to type
        hook: hook.bind(null, "request")
      }),
      mediaType: {
        previews: [],
        format: ""
      }
    };
    requestDefaults.headers["user-agent"] = options.userAgent ? "".concat(options.userAgent, " ").concat(userAgentTrail) : userAgentTrail;

    if (options.baseUrl) {
      requestDefaults.baseUrl = options.baseUrl;
    }

    if (options.previews) {
      requestDefaults.mediaType.previews = options.previews;
    }

    if (options.timeZone) {
      requestDefaults.headers["time-zone"] = options.timeZone;
    }

    this.request = request.defaults(requestDefaults);
    this.graphql = withCustomRequest(this.request).defaults(requestDefaults);
    this.log = Object.assign({
      debug: noop,
      info: noop,
      warn: consoleWarn,
      error: consoleError
    }, options.log);
    this.hook = hook;

    if (!options.authStrategy) {
      if (!options.auth) {
        this.auth = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", {
                    type: "unauthenticated"
                  });

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
      } else {
        var auth = createTokenAuth(options.auth);
        hook.wrap("request", auth.hook);
        this.auth = auth;
      }
    } else {
      var authStrategy = options.authStrategy,
          otherOptions = _objectWithoutProperties(options, _excluded);

      var _auth = authStrategy(Object.assign({
        request: this.request,
        log: this.log,
        // we pass the current octokit instance as well as its constructor options
        // to allow for authentication strategies that return a new octokit instance
        // that shares the same internal state as the current one. The original
        // requirement for this was the "event-octokit" authentication strategy
        // of https://github.com/probot/octokit-auth-probot.
        octokit: this,
        octokitOptions: otherOptions
      }, options.auth));

      hook.wrap("request", _auth.hook);
      this.auth = _auth;
    }

    var classConstructor = this.constructor;

    for (var i = 0; i < classConstructor.plugins.length; ++i) {
      Object.assign(this, classConstructor.plugins[i](this, options));
    }
  }

  _createClass(Octokit, null, [{
    key: "defaults",
    value: function defaults(_defaults) {
      var OctokitWithDefaults = /*#__PURE__*/function (_this) {
        _inherits(OctokitWithDefaults, _this);

        var _super = _createSuper(OctokitWithDefaults);

        function OctokitWithDefaults() {
          var _this2;

          _classCallCheck(this, OctokitWithDefaults);

          var options = (arguments.length <= 0 ? undefined : arguments[0]) || {};

          if (typeof _defaults === "function") {
            _this2 = _super.call(this, _defaults(options));
            return _possibleConstructorReturn(_this2);
          }

          return _super.call(this, Object.assign({}, _defaults, options, options.userAgent && _defaults.userAgent ? {
            userAgent: "".concat(options.userAgent, " ").concat(_defaults.userAgent)
          } : null));
        }

        return _createClass(OctokitWithDefaults);
      }(this);

      return OctokitWithDefaults;
    }
  }, {
    key: "plugin",
    value:
    /**
     * Attach a plugin (or many) to your Octokit instance.
     *
     * @example
     * const API = Octokit.plugin(plugin1, plugin2, plugin3, ...)
     */
    function plugin() {
      var _class2,
          _arguments = arguments;

      var currentPlugins = this.plugins;
      var NewOctokit = (_class2 = /*#__PURE__*/function (_this3) {
        _inherits(NewOctokit, _this3);

        var _super2 = _createSuper(NewOctokit);

        function NewOctokit() {
          _classCallCheck(this, NewOctokit);

          return _super2.apply(this, arguments);
        }

        return _createClass(NewOctokit);
      }(this), function () {
        for (var _len = _arguments.length, newPlugins = new Array(_len), _key = 0; _key < _len; _key++) {
          newPlugins[_key] = _arguments[_key];
        }

        _class2.plugins = currentPlugins.concat(newPlugins.filter(function (plugin) {
          return !currentPlugins.includes(plugin);
        }));
      }(), _class2);
      return NewOctokit;
    }
  }]);

  return Octokit;
}(), _class.VERSION = VERSION, _class.plugins = [], _class);
export { Octokit };